import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuncionalidadeService } from 'src/app/service/funcionalidade.service';
import { aplicarFiltrosConsulta } from 'src/app/util/consulta/wow-consulta.util';
import { Funcionalidade } from './funcionalidade';

@Component({
  selector: 'app-funcionalidade-consulta',
  templateUrl: './funcionalidade-consulta.component.html',
  styleUrls: [
    './funcionalidade-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class FuncionalidadeConsultaComponent {

  funcionalidades: Funcionalidade[] = [];
  tipoFiltros = ['ID', 'Descrição'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;
  consultaRealizada = false;

  constructor(
    private service: FuncionalidadeService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  consultar() {
    this.service.listar().subscribe(lista => {
      this.funcionalidades = aplicarFiltrosConsulta(lista ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: f => f.id,
        nome: f => f.descricao,
        ativo: f => f.ativo !== false,
      });
      this.consultaRealizada = true;
    }, () => this.snackBar.open('Erro ao listar funcionalidades.', 'ERRO', { duration: 2500 }));
  }

  novo() {
    this.router.navigate(['/funcionalidade/form']);
  }

  editar(funcionalidade: Funcionalidade) {
    if (funcionalidade.id) {
      this.router.navigate(['/funcionalidade/form', funcionalidade.id]);
    }
  }

  inativar(funcionalidade: Funcionalidade) {
    if (!funcionalidade.id || !confirm('Inativar esta funcionalidade?')) {
      return;
    }
    this.service.inativar(funcionalidade.id).subscribe(() => {
      this.snackBar.open('Funcionalidade inativada.', 'OK', { duration: 2000 });
      this.consultar();
    });
  }
}
